export const iconFontAwesomeGendersMarsAndVenus = (
	<i className="fa-solid fa-mars-and-venus"></i>
);
